import styled from "styled-components";
import { Box, TextField, Paper } from "@mui/material";
import Button from "../../components/Button";
import { SPACING } from "../../utils/constants";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary-color-background);
  padding: 20px;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

// Focused login shell: neutral body surface so the brand accent stays reserved
// for the primary action, never tiled as a background (see DESIGN.md Rarity Rule).
export const LoginContainer = styled(Container)`
  background: var(--color-background-0);
`;

export const ContentWrapper = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 1200px;
  align-items: center;
  justify-content: center;
  gap: 48px;

  @media (max-width: 900px) {
    max-width: 480px;
  }
`;

export const CardSection = styled(Box)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const FeatureSection = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const Card = styled(Paper)`
  padding: 48px 40px;
  border-radius: 16px;
  box-shadow: var(--shadow-xlarge);
  background: var(--color-background-2);
  max-width: 480px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 32px 24px;
  }
`;

export const BrandSection = styled(Box)`
  text-align: center;
  margin-bottom: 32px;
`;

export const BrandIcon = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 16px;
  background: var(--color-white);
  margin-bottom: 16px;
  color: var(--color-white);
  font-size: var(--text-display);
`;

export const GoogleButton = styled(Button)`
  margin-bottom: ${SPACING.lg}px;
`;

export const ScrollTopSlot = styled.div`
  position: fixed;
  right: ${SPACING.lg}px;
  bottom: ${SPACING.lg}px;
  z-index: 1000;
`;

export const FeatureGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 48px;
`;

export const FeatureCard = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  background: var(--overlay-white-10);
  border-radius: 12px;
  color: var(--color-white);
`;

export const StyledTextField = styled(TextField)`
  && {
    margin-bottom: 16px;

    .MuiOutlinedInput-root {
      border-radius: 8px;

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: var(--color-primary);
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: var(--color-primary);
      }
    }
  }
`;

// Styled components specific to Privacy Policy
export const PrivacyContainer = styled(Container)`
  background: var(--color-background-0);
  min-height: 100vh;
  padding: 40px 20px;
`;

export const PrivacyCard = styled(Card)`
  max-width: 900px;
  margin: 0 auto;
  padding: 48px 40px;
  /* A full-page document, not a floating modal: subtle lift + hairline, not --shadow-xlarge. */
  box-shadow: var(--shadow-small);
  border: 1px solid var(--color-border);

  @media (max-width: 600px) {
    padding: 32px 24px;
  }
`;

export const SectionCard = styled(Box)`
  background: var(--color-background-0);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  border: 1px solid var(--color-border);
`;

export const TableOfContents = styled(Box)`
  background: color-mix(in srgb, var(--color-primary) 4%, transparent);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid color-mix(in srgb, var(--color-primary) 15%, transparent);
`;
